import {Tooltip} from 'platform/components';
import {Text} from 'platform/foundation';
import {useDateTimeFormatter} from 'platform/locale';

import {parseDate} from 'shared/web';

import {EMPTY_CELL_PLACEHOLDER} from '../../constants/cellPlaceholder';
import {CellRendererProps} from '../../types/CellRendererProps';
import {CellStyle} from '../../types/CellStyle';
import {TooltipGetter} from '../../types/TooltipGetter';
import {getCellClassName} from '../../utils/getCellClassName';
import {getStylesToRender} from '../../utils/getStylesToRender';
import {getTooltipProps} from '../../utils/getTooltipProps';

type DateCellRendererProps = CellRendererProps<string | null> & {
  getTooltipProps?: TooltipGetter;
};

export function DateCellRenderer(props: DateCellRendererProps) {
  const className = getCellClassName(props.isWrap);
  const cellStyles = getStylesToRender<CellStyle>(props);
  const formatDateTime = useDateTimeFormatter();
  const tooltipProps = getTooltipProps(props.row, props.getTooltipProps);

  const parsed = props.value ? parseDate(props.value) : null;

  if (parsed == null || isNaN(parsed.getTime())) {
    return (
      <div className={className}>
        <Text noWrap={!props.isWrap} size="small">
          {props.emptyCellValue ?? EMPTY_CELL_PLACEHOLDER}
        </Text>
      </div>
    );
  }

  return (
    <Tooltip {...tooltipProps} label={formatDateTime('dateTimeLong', parsed)}>
      <div className={className}>
        <Text
          color={cellStyles?.textColor}
          noWrap={!props.isWrap}
          size="small"
          overflowWrap={props.isWrap ? 'anywhere' : undefined}
        >
          {formatDateTime('dateShort', parsed)}
        </Text>
      </div>
    </Tooltip>
  );
}
